import { render, staticRenderFns } from "./AvContractWidget.vue?vue&type=template&id=66ed392b&scoped=true&"
import script from "./AvContractWidget.vue?vue&type=script&lang=js&"
export * from "./AvContractWidget.vue?vue&type=script&lang=js&"
import style0 from "./AvContractWidget.vue?vue&type=style&index=0&id=66ed392b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed392b",
  null
  
)

component.options.__file = "AvContractWidget.vue"
export default component.exports